import styled from 'styled-components';
import { LayoutType } from '../../types';

import BoxImage from './assets/box.png';
import BarImage from './assets/bar.png';
import ButtonImage from './assets/button.png';
import FooterImage from './assets/footer.png';

interface SiteContextPreviewProps {
	layout: LayoutType
}

const Container = styled.div`
	width: 100%;
	text-align: center;
`;

const Image = styled.img`
	width: 100%;
	max-width: 460px;
`;

const getImageSrcByType = (type: LayoutType) => {
	switch (type) {
		case 'box':
			return BoxImage;
		case 'bar':
			return BarImage;
		case 'button':
			return ButtonImage;
		case 'footer':
			return FooterImage;
		default:
			return '';
	}
};

function SiteContextPreview({ layout }: SiteContextPreviewProps) {
	return (
		<Container>
			<Image src={getImageSrcByType(layout)} alt={`${layout} contribution site context preview`} />
		</Container>
	)
}

export default SiteContextPreview;
